import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";
import { Bdap, UpsertBdapPayload } from "./bdapTypes";

export const bdapApi = createApi({
  reducerPath: "bdapApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["bdap"],
  endpoints: (builder) => ({
    getBdap: builder.query<Response<Bdap | null>, void>({
      query: () => ({
        url: "bdap",
        method: "GET",
      }),
      providesTags: ["bdap"],
    }),
    upsertBdap: builder.mutation<Response<Bdap>, UpsertBdapPayload>({
      query: (data) => ({
        url: "bdap",
        method: "POST",
        data,
      }),
      invalidatesTags: ["bdap"],
    }),
  }),
});

export const { useGetBdapQuery, useUpsertBdapMutation } = bdapApi;
